<template>
  <v-row class="specify-border">
    <v-col cols="12" md="4" class="accent2 d-flex align-center"
           :class="this.$vuetify.breakpoint.mdAndUp ? 'text-body-1 pa-8 justify-end' : 'pa-4 font-weight-bold'">
      <template v-if="!hideItemName">{{ itemName }}</template>
      <slot name="title"></slot>
      <v-chip v-if="required" label color="red darken-2" small class="white--text mx-1 px-1 rounded-0">必須</v-chip>
    </v-col>
    <v-col cols="12" md="8" :class="this.$vuetify.breakpoint.mdAndUp ? 'pa-8' : 'pa-4'" class="d-flex align-center white">
      <v-sheet class="d-flex text-body-1" width="100%">
        <slot name="input"></slot>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "vb-form-row",
  props: {
    itemName: {type: String, required: true},
    required: {type: Boolean, default: false, required: false},
    hideItemName: {type: Boolean, default: false, required: false}
  },
}
</script>

<style scoped lang="scss">
.specify-border {
    position: relative;
    &:after {
        content: "";
        display: block;
        border-top: 1px solid #FBFAF5;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
    }
}
.row {
  margin-top: 0;
  margin-bottom: 0;
}
</style>